import { DatePicker } from "@/components/ui/date-picker";

/**
 * Drop-in for <input type="date"> / <input type="datetime-local">: same `value` string and
 * `onChange(e)` with `e.target.value`, rendered with the app's date picker. Dark forms are
 * detected from the input class they used to carry.
 */
export default function DateInput({ value, onChange, className = "", min, max, disabled, required, withTime, placeholder, dark }: {
  value?: string | null;
  onChange?: (e: { target: { value: string } }) => void;
  className?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  required?: boolean;
  withTime?: boolean;
  placeholder?: string;
  dark?: boolean;
}) {
  const isDark = dark ?? /\bbg-gray-9\d\d\b|\bbg-black\b/.test(className);
  return (
    <DatePicker
      value={value ?? ""}
      onChange={(v) => onChange?.({ target: { value: v } })}
      min={min}
      max={max}
      disabled={disabled}
      required={required}
      withTime={withTime}
      placeholder={placeholder}
      dark={isDark}
      clearable={!required}
    />
  );
}
